// §29.4 / §9.1 — Pyramid as an in-process app. The manifest only (D-247).
import type { ArcadeShellAccess, InProcessApp } from '@hangar/shared';
import { createLazyApp } from '@/gamekit/lazy';

export function createPyramidApp(access: ArcadeShellAccess): InProcessApp {
  return createLazyApp<{ access: ArcadeShellAccess }>({
    app: {
      id: 'pyramid',
      name: 'Pyramid',
      // D-379's glyph, and it exists upstream in lucide-react 1.28.0 — no substitution needed.
      icon: { glyph: 'pyramid', hue: 48 },
      keywords: ['cards', 'pyramid', 'patience', 'solitaire', 'thirteen', 'game', 'arcade'],
      category: 'Arcade',
      group: 'Cards',
      requiresAuth: true,
      window: { width: 900, height: 760, minWidth: 600, minHeight: 520, multiWindow: false },
      jumpList: [
        { id: 'new-game', label: 'New game' },
        { id: 'daily-deal', label: 'Daily deal' },
      ],
    },
    load: () => import('./Pyramid'),
    props: { access },
  });
}
